import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M12 5a6 6 0 0 0-6 6v6.5h12V11a6 6 0 0 0-6-6m6.75 14H4a.75.75 0 0 1 0-1.5h.5V11a7.5 7.5 0 0 1 6.75-7.462V2.75a.75.75 0 0 1 1.5 0v.787A7.5 7.5 0 0 1 19.5 11v6.5h.5a.75.75 0 0 1 0 1.5zm-5.173 1.504L13.5 20.5h-3a.75.75 0 0 0 0 1.5h3l.077-.004a.75.75 0 0 0 0-1.492",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }